//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import ReportProjectField from './ReportProjectField'

export default {
  name: 'ReportProjectSection',
  components: {
    ReportProjectField
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    insideReportRoads: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      expanded: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    mobile: function () {
      return this.user.view === 'mobile'
    },
    editable: function () {
      return !this.insideReportRoads && !!this.report.actionsAccess.saveAccess // && this.report.stateId !== 'PR7'
    },
    readonly: function () {
      return !(this.editable && !this.report.actionsAccess.reinforcementExecutor)
      // return !(this.report.actionsAccess && this.report.actionsAccess.editData)
    }
  },
  created: function () {
    if (!this.mobile) {
      this.expanded = true
    }
  },
  methods: {
    validate: function (action) {
      let fields
      if (Array.isArray(this.$refs.field)) {
        fields = this.$refs.field
      } else {
        fields = [this.$refs.field]
      }
      let valid = true
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i]
        valid = valid && field.validate(action)
      }
      return valid
    }
  }
}
